Vue.component("VideoEmbed", {
    props: ["config"],

    data () {
        return {
            paused: true,
            showInterface: false
        }
    },
    template: `
    
        <div class="videoEmbed">


            <video :src="config.src" 
                :poster="config.poster"
                width="100%" 
                height="100%"
                autoplay
                loop
                playsinline
                />


            <div class="videoUi" @click="togglePause" >
                
                    <li class="hotspot Stream hotspot--active" v-if="paused" >
                        <div class="hotspot-button" style="animation-name: loopPulse; animation-iteration-count: infinite; animation-duration: 15s; animation-delay: 1.5s;"></div>
                    </li>


            </div>
            
        </div>


    `,

    mounted () {

        this.eventHandlers = [];
        this.video = this.$el.querySelector("video");

        this.eventHandlers["playing"] = () => {
            console.log("video playing")

            this.paused = false;
            this.showInterface = false;
        };

        this.video.addEventListener("playing",  this.eventHandlers["playing"])

        this.eventHandlers["pause"] = () => {
            console.log("video paused")
            this.paused = true;
            this.showInterface = true;
        }

        this.video.addEventListener("pause",  this.eventHandlers["pause"] );

        this.eventHandlers["force-pause"] = () => {
            console.log("pausing video embed")
            this.video.pause();
        }
        
        this.eventHandlers["force-play"] = () => {
            console.log("playing video embed")
            this.video.play();
        }
        app.radio.$on("component-close", this.eventHandlers["force-pause"])
        app.radio.$on("component-open", this.eventHandlers["force-play"])

        // Sins we are using autoplay, we want to check if the video is playing, 
        // if that is not the case, we will display the ui. allowing the user to 
        // start the video.
        setTimeout(()=> {
            if(this.video.paused) {
                this.showInterface = true;
            }
        }, 1000);
    },

    destroyed () {
        this.video.pause();
        // Object.keys(this.eventHandlers).forEach(event => {
        //     this.video.removeEventListener(event, this.eventHandlers[event]);
        // })

        this.video.removeEventListener("playing", this.eventHandlers["playing"]);
        this.video.removeEventListener("pause", this.eventHandlers["pause"]);
        app.radio.$off("component-close", this.eventHandlers["force-pause"])
        app.radio.$off("component-open", this.eventHandlers["force-play"])


    },

    methods: {
        togglePause () {
            this.video.paused ? this.video.play() : this.video.pause();
        }
    }
});